export enum StartWorkDoneResponseItemPriority {
  None,
  P2 = 2,
  P3,
  P4,
}
